<template>
  <div class="ctrl">
    <div class="ctrl-window__overlay" v-if="showLinksEditor" @click="closeEditor"></div>
    <transition name="fade">
        <div class="ctrl-window" v-if="showLinksEditor" width="300px">
            <div class="ctrl__header">
                <h3 class="ctrl__title">Share link</h3>
                <div @click="closeEditor">
                    <IconBase
                        :height="24"
                        :width="24"
                        :view-box="`0 0 24 24`"
                        :fill="'#E7E6FA'"
                    >
                        <IconCross />
                    </IconBase>
                </div>
            </div>
            <p v-if="sharedLinks.length" style="margin-bottom: 8px">Links shared in this room</p>
            <div class="links-container">
                <div v-for="(link, index) in sharedLinks" :key="index">
                    <EditLink :link="link" :index="index" @link-deleted="deleteSharedLink" />
                </div>
            </div>
            <hr class="divider">
            <p>Add link you want to share</p>
            <div class="ctrl__form">
                <el-form @submit.prevent.native="addLink">
                    <el-row>
                        <el-col :span="20">
                            <el-input class="add-link-input" :span="10" placeholder="e.g. https://www.berst.io" v-model="link" size="small" @input="invalid=false">
                            </el-input>
                        </el-col>
                        <el-col :span="4">
                            <el-button class="add-button" @click="addLink">
                                <IconBase
                                    :height="24"
                                    :width="24"
                                    :view-box="`0 0 24 24`"
                                    :fill="'#E7E6FA'"
                                >
                                    <IconPlus />
                                </IconBase>
                                <span class="button-text">
                                    Add
                                </span>
                            </el-button>
                        </el-col>
                    </el-row>
                    <div class="error-text">{{ invalid ? 'Invalid link!': ''}}</div>
                </el-form>
            </div>
        </div>
    </transition>
  </div>
</template>

<script>
import IconBase from '../IconBase'
import IconCross from '../icons/IconCross'
import IconPlus from '../icons/IconPlus'
import EditLink from './EditLink'
export default {
    name: "ShareLinks",
    props: ['showLinksEditor', 'sharedLinks'],
    components: {
        IconBase,
        IconCross,
        IconPlus,
        EditLink
    },
    data(){
        return {
            link: null,
            invalid: false,
        }
    },

    methods: {
        closeEditor(){
            this.$emit('editor-closed')
        },

        validateLink(){
            // eslint-disable-next-line no-useless-escape
            const regExp = RegExp(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/)
            return this.link && this.link.match(regExp)
        },

        addLink(){
            if(this.validateLink()){
                this.$emit('link-added', this.link)
                this.link = null
            }else{
                this.invalid = true
            }
        },

        deleteSharedLink(index){
            this.$emit('link-deleted', index)
        }
    }
}
</script>

<style scoped>
p {
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    color: #E7E6FA;
}
.ctrl-window__overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vmax;
    background: #000;
    opacity: 0.5;
    z-index: 1;
}

.ctrl-window {
    position: absolute;
    width: 480px;
    max-height: 360px;
    top: calc(50% - 360px / 2);
    left: calc(50% - 480px / 2);
    background: #2A2A3D;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    text-align: left;
    padding: 0 12px;
    z-index: 2;
}
.ctrl__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.ctrl__title {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #E7E6FA;
}
.ctrl__footer {
    display: flex;
    justify-content: flex-end;
}
.ctrl__form {
    margin-bottom: 24px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.links-container {
    max-height: calc(360px / 2);
    overflow-y: auto;
}

.el-input .el-input__inner{
    color: #E7E6FA;
    font-weight: 400;
    height: 36px;
    font-family: Arial, Helvetica, sans-serif;
}
>>>.el-input .el-input__inner::-webkit-input-placeholder{ /* Edge */
    color: rgba(231, 230, 250, 0.4);
    font-family: inherit;
}

>>>.el-input .el-input__inner:-ms-input-placeholder{ /* Internet Explorer 10-11 */
    color: rgba(231, 230, 250, 0.4);
    font-family: inherit;
}

>>>.el-input .el-input__inner::placeholder{
    color: rgba(231, 230, 250, 0.4);
    font-family: inherit;
}

.el-button.add-button,
.el-button.add-button:hover {
    padding: 0;
    margin: 0;
    position: relative;
    left: -25px;
    width: 91px;
    height: 36px;
    background: #2A2A3D;
    border: 1px solid #E7E6FA;
    box-sizing: border-box;
    border-radius: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #E7E6FA;
}
>>>button.el-button.add-button span,
>>>button.el-button.add-button.is-disabled span{
    display: flex;
    justify-content: center;
    align-items: center;
}
.button-text {
    padding: 3px 0px 0 10px;
}

.divider {
    margin: 0;
    height: 0px;
    width: 100%;
    border: 1px solid #393752;
}

div.error-text {
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    color: #E05A5A;
}
</style>